import {request} from '../../lib/api.js'
const interaction=value=>typeof value==='string'&&/^[A-Za-z0-9_.:@-]{1,200}$/.test(value)
const path='/native-connection/portal-session/continue'
export function selectedNativeInteraction(search){
  const params=new URLSearchParams(search)
  return [...params.keys()].length===1&&params.getAll('interactionId').length===1&&interaction(params.get('interactionId'))?params.get('interactionId'):null
}
export function normalizeNativeContinuation(value,interactionId,origin){
  if(!interaction(interactionId)||value?.ok!==true||value.interactionId!==interactionId||typeof value.handoff!=='string'||!/^native-handoff-[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}\.[a-f0-9]{64}$/.test(value.handoff)||typeof value.continueUrl!=='string')throw Error('native_continuation_invalid')
  const url=new URL(value.continueUrl)
  // Do not allow a server response to turn a handoff into arbitrary navigation
  // or disclosure. No query, fragment, credentials, encoded path or redirect.
  if(!['https://api.srchamp.com',origin].includes(url.origin)||!['https:','http:'].includes(url.protocol)||url.pathname!==path||url.search||url.hash||url.username||url.password||value.continueUrl!==url.origin+path)throw Error('native_continuation_target_invalid')
  return {continueUrl:url.href,interactionId,handoff:value.handoff}
}
export const nativeConnectionContinueApi={
  start(interactionId,{signal}={}){
    if(!interaction(interactionId))throw Error('native_interaction_invalid')
    return request('/api/native-connection/portal-session',{method:'POST',body:{interactionId},headers:{'X-SR-Native-Intent':'continue-connection'},signal,audit:{redact:true,action:'continue-native-connection'}})
  },
}
export function submitNativeContinuation(value,interactionId,{document,origin}){
  const exact=normalizeNativeContinuation(value,interactionId,origin),form=document.createElement('form')
  form.method='POST';form.action=exact.continueUrl;form.target='_self';form.hidden=true
  try{
    for(const name of ['interactionId','handoff']){const input=document.createElement('input');input.type='hidden';input.name=name;input.value=exact[name];form.append(input)}
    document.body.append(form);form.submit()
  }finally{form.remove()}
}
